module.exports = __webpack_public_path__ + "static/media/bike-project.bcc111c3.png";